import {Component, OnInit, ElementRef, Output, EventEmitter, Input} from '@angular/core';

import * as moment from 'moment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {
  @Input() public initialDate;
  @Input() public finalDate;

  @Output() public filter = new EventEmitter();

  public year = 0;
  public month = 0;

  public todayDate: Date = null;

  public daysInMonth = 0;
  public weeksInMonth = 0;

  public countSelection = 0;

  public lastSelectionDay = 0;
  public firstSelectionDay = 0;

  public lastSelectionMonth = 0;
  public firstSelectionMonth = 0;

  public lastSelectionYear = 0;
  public firstSelectionYear = 0;

  public showCalendar = false;

  public firstWeekDayInMonth = 0;

  public calendarMatrix: number[][] = [];

  public weekdays: string[] = [
    'dom',
    'seg',
    'ter',
    'qua',
    'qui',
    'sex',
    'sab'
  ];

  public months: string[] = [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro'
  ];

  toDateContext = false;
  fromDateContext = false;

  constructor(
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    this.initialDate && this.finalDate ? this.setCustomDate() : this.setCurrentMonth();
    this.clickOutListener();
  }

  setCustomDate() {
    this.todayDate = this.finalDate.getDate();
    this.month = this.finalDate.getMonth();
    this.year = this.finalDate.getFullYear();

    this.setMonthData();

    this.firstSelectionDay = this.initialDate.getDate();
    this.firstSelectionMonth = this.initialDate.getMonth();
    this.firstSelectionYear = this.initialDate.getFullYear();

    this.lastSelectionDay = this.finalDate.getDate();
    this.lastSelectionMonth = this.finalDate.getMonth();
    this.lastSelectionYear = this.finalDate.getFullYear();

    this.emitDateEvent();

    const self = this;
    setTimeout(function() {
      const tds = self.elRef.nativeElement.querySelectorAll('.calendar-frame table tbody tr td');
      for (let i = 0; i < tds.length; i++) {
        if (parseInt(tds[i].innerHTML, 10) === self.lastSelectionDay) {
          tds[i].classList.add('last');
        } else {
          if (parseInt(tds[i].innerHTML, 10) < self.lastSelectionDay) {
            tds[i].classList.add('middle');
          }
        }
      }
    }, 100);

    this.countSelection = 2;
  }

  setCurrentMonth() {
    this.todayDate = new Date();
    this.month = this.todayDate.getMonth();
    this.year = this.todayDate.getFullYear();

    this.setMonthData();
    this.setInitialFilter();
  }

  toggleCalendar(param?: string) {
    this.showCalendar = !this.showCalendar;

    if ( this.showCalendar && param ) {
      this.toDateContext = param === 'toDate';
      this.fromDateContext = param === 'fromDate';
    }
    if ( !this.showCalendar ) {
      this.toDateContext = false;
      this.fromDateContext = false;
    }

  }

  setInitialFilter() {
    this.firstSelectionDay = new Date().getDate();
    this.firstSelectionMonth = new Date().getMonth() === 1 ? 12 : (new Date().getMonth() - 1) < 0 ? 11 : new Date().getMonth() - 1;
    this.firstSelectionYear = new Date().getMonth() === 1 ?
                              new Date().getFullYear() - 1 :
                              (new Date().getMonth() - 1) < 0 ?
                              new Date().getFullYear() - 1 :
                              new Date().getFullYear();

    this.lastSelectionDay = new Date().getDate();
    this.lastSelectionMonth = new Date().getMonth();
    this.lastSelectionYear = new Date().getFullYear();

    this.emitDateEvent();

    this.renderClassesBySelectedMonth().then();

    this.countSelection = 2;
  }

  setMonthData() {
    this.daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
    this.weeksInMonth = Math.floor((new Date(this.year, this.month + 1, 0).getDate() - 1) / 7) + 1;
    this.firstWeekDayInMonth = new Date(this.year, this.month, 1).getDay();

    this.setCalendarMatrix();
  }

  setCalendarMatrix() {
    let daysCount = 0;
    const rows = [];
    let columns = [];
    for (let i = 1; i <= 6; i++) {
      for (let j = 1; j <= 7; j++) {
        if (i === 1 && j <= this.firstWeekDayInMonth) {
          columns.push(null);
        } else {
          if (daysCount < this.daysInMonth) {
            columns.push(daysCount + 1);
          } else {
            columns.push(null);
          }
          daysCount++;
        }
      }
      rows.push(columns);
      columns = [];
    }
    this.calendarMatrix = rows;
  }

  async nextMonth(e) {
    this.year = this.month === 11 ? this.year + 1 : this.year;
    this.month = this.month === 11 ? 0 : this.month + 1;

    this.setMonthData();

    await this.renderClassesBySelectedMonth();
  }

  async prevMonth(e) {
    this.year = this.month === 0 ? this.year - 1 : this.year;
    this.month = this.month === 0 ? 11 : this.month - 1;

    this.setMonthData();

    await this.renderClassesBySelectedMonth();
  }

  async renderClassesBySelectedMonth(): Promise<void> {

    return Promise.resolve().then( async() => {
      setTimeout(async () => {

        const days = this.elRef.nativeElement.querySelectorAll('.calendar-frame table tbody tr td');

          for await ( const day of days ) {
            day.classList.remove('first', 'last', 'middle');

            const dayValue = parseInt(day.innerHTML, 10);

            if ( typeof dayValue === 'number' && dayValue > 0) {

              if (this.firstSelectionYear === this.year && this.lastSelectionYear === this.year) {

                if ( this.month < this.lastSelectionMonth && this.month > this.firstSelectionMonth ) {
                  day.classList.add('middle');
                }

                if (
                  this.firstSelectionMonth === this.month &&
                  this.lastSelectionMonth === this.month
                ) {

                  if (dayValue === this.firstSelectionDay) {
                    day.classList.add('first');
                  }

                  if (dayValue === this.lastSelectionDay) {
                    day.classList.add('last');
                  }

                  if (dayValue > this.firstSelectionDay && dayValue < this.lastSelectionDay) {
                    day.classList.add('middle');
                  }
                }

                if (this.month === this.firstSelectionMonth && this.month < this.lastSelectionMonth) {

                  if (dayValue === this.firstSelectionDay) {
                    day.classList.add('first');
                  }

                  if (dayValue > this.firstSelectionDay) {
                    day.classList.add('middle');
                  }
                }

                if (this.month === this.lastSelectionMonth && this.month > this.firstSelectionMonth ) {

                  if (dayValue < this.lastSelectionDay) {
                    day.classList.add('middle');
                  }
                  if (dayValue === this.lastSelectionDay) {
                    day.classList.add('last');
                  }
                }
              }
              if ( this.year < this.lastSelectionYear && this.year === this.firstSelectionYear ) {

                if ( this.month > this.firstSelectionMonth ) {
                  day.classList.add('middle');
                }

                if ( this.month === this.firstSelectionMonth ) {

                  if (dayValue === this.firstSelectionDay) {
                    day.classList.add('first');
                  }

                  if (dayValue > this.firstSelectionDay) {
                    day.classList.add('middle');
                  }
                }
              }

              if (this.year > this.firstSelectionYear && this.year === this.lastSelectionYear) {

                if ( this.month < this.lastSelectionMonth ) {
                  day.classList.add('middle');
                }

                if ( this.month === this.firstSelectionMonth ) {

                  if (dayValue === this.firstSelectionDay) {
                    day.classList.add('first');
                  }

                  if (dayValue > this.firstSelectionDay) {
                    day.classList.add('middle');
                  }
                }

                if ( this.month === this.lastSelectionMonth ) {

                  if (dayValue === this.lastSelectionDay) {
                    day.classList.add('last');
                  }

                  if (dayValue < this.lastSelectionDay) {
                    day.classList.add('middle');
                  }
                }
              }

              if (this.year > this.firstSelectionYear && this.year < this.lastSelectionYear) {
                day.classList.add('middle');
              }
            }
          }
      }, 100);
    });
  }

  selectMiddle(e) {
    if (this.countSelection === 1 && Number.isInteger(parseInt(e.target.innerHTML, 10))) {
      this.lastSelectionDay = parseInt(e.target.innerHTML, 10);
      const tds = this.elRef.nativeElement.querySelectorAll('.calendar-frame table tbody tr td');
      for (let i = 0; i < tds.length; i++) {
        tds[i].classList.remove('middle');
        if (this.firstSelectionMonth === this.month) {
          if (this.firstSelectionDay < this.lastSelectionDay) {
            if (
              parseInt(tds[i].innerHTML, 10) > this.firstSelectionDay &&
              parseInt(tds[i].innerHTML, 10) < this.lastSelectionDay
            ) {
              tds[i].classList.add('middle');
            }
          } else {
            if (
              parseInt(tds[i].innerHTML, 10) < this.firstSelectionDay &&
              parseInt(tds[i].innerHTML, 10) > this.lastSelectionDay
            ) {
              tds[i].classList.add('middle');
            }
          }
        } else {
          if (
            this.month > this.firstSelectionMonth &&
            parseInt(tds[i].innerHTML, 10) >= 1 &&
            parseInt(tds[i].innerHTML, 10) < parseInt(e.target.innerHTML, 10)
          ) {
            tds[i].classList.add('middle');
          } else {
            if (
              this.month < this.firstSelectionMonth &&
              parseInt(tds[i].innerHTML, 10) <= this.daysInMonth &&
              parseInt(tds[i].innerHTML, 10) > parseInt(e.target.innerHTML, 10)
            ) {
              tds[i].classList.add('middle');
            }
          }
        }
      }
    }
  }

  customSelection(e) {

    if (e.target.innerHTML === '') { return; }

    if (this.countSelection === 2 ) {

      if (this.fromDateContext) {
        this.clearFirstDay();
      }
      if (this.toDateContext) {
        this.clearLastDay();
      }
    }

    let element = null;

    if (e.target) {
      element = e.target;
    } else {
      element = e;
    }

    if (this.countSelection === 0) {
      element.classList.add('first');
      this.firstSelectionDay = parseInt(element.innerHTML, 10);
      this.firstSelectionMonth = this.month;
      this.firstSelectionYear = this.year;
      this.countSelection++;
      return;
    }

    if (this.countSelection === 2) {
      element.classList.add('first');
      this.firstSelectionDay = parseInt(element.innerHTML, 10);
      this.firstSelectionMonth = this.month;
      this.firstSelectionYear = this.year;
    }

    this.calculateDateafterSetLastDate(element);

  }

  calculateDateafterSetLastDate(element?) {

    if (this.countSelection === 1) {

      if (element) {
          element.classList.add('last');
        }

        const lastSelectionDay = parseInt(element.innerHTML, 10);
        const lastSelectionMonth = this.month;
        const lastSelectionYear = this.year;

        const firstDate = new Date(this.firstSelectionYear, this.firstSelectionMonth, this.firstSelectionDay);
        const lastDate = new Date(lastSelectionYear, lastSelectionMonth, lastSelectionDay);

        if (moment(firstDate).isAfter(lastDate)) {
          const _firstSelectionDay = this.firstSelectionDay;
          const _firstSelectionMonth = this.firstSelectionMonth;
          const _firstSelectionYear = this.firstSelectionYear;

          this.firstSelectionDay = lastSelectionDay;
          this.firstSelectionMonth = lastSelectionMonth;
          this.firstSelectionYear = lastSelectionYear;

          this.lastSelectionDay = _firstSelectionDay;
          this.lastSelectionMonth = _firstSelectionMonth;
          this.lastSelectionYear = _firstSelectionYear;
        } else {
          this.lastSelectionDay = parseInt(element.innerHTML, 10);
          this.lastSelectionMonth = this.month;
          this.lastSelectionYear = this.year;
        }

        const tds = this.elRef.nativeElement.querySelectorAll('.calendar-frame table tbody tr td');
        for (let i = 0; i < tds.length; i++) {
          tds[i].classList.remove('middle');
          /*se o mês do atual calendario for o mesmo do mes da primeira seleção*/
          if (this.firstSelectionMonth === this.month) {
            if (this.firstSelectionDay < this.lastSelectionDay) {
              if (parseInt(tds[i].innerHTML, 10) > this.firstSelectionDay && parseInt(tds[i].innerHTML, 10) < this.lastSelectionDay) {
                tds[i].classList.add('middle');
              }
            } else {
              if (
                parseInt(tds[i].innerHTML, 10) < this.firstSelectionDay &&
                parseInt(tds[i].innerHTML, 10) > this.lastSelectionDay
              ) {
                tds[i].classList.add('middle');
              }
            }
          } else {
            /*se o mês do atual calendario for maior que o mês da primeira seleção E o qudrado do loop for estiver preenchido com valor maior que 1 E
            * e o quadrado do loop for atual for, tiver o valor menor que o quadrado enviado pelo clicado pelo usuário
            * */
            if (
              this.month > this.firstSelectionMonth &&
              parseInt(tds[i].innerHTML, 10) >= 1 &&
              parseInt(tds[i].innerHTML, 10) < parseInt(element.innerHTML, 10)) {
              tds[i].classList.add('middle');
            } else {
              /* se o Mes do calendario atual for menor que o mes ja selecionado na primeira seleçao E
              * o quadrado atual do loop for menor que os dias do mês e o quadrado atual for maior que o recebido pelo parametro
              */
              if (
                this.month < this.firstSelectionMonth &&
                parseInt(tds[i].innerHTML, 10) <= this.daysInMonth &&
                parseInt(tds[i].innerHTML, 10) > parseInt(element.innerHTML, 10)
              ) {
                tds[i].classList.add('middle');
              }
            }
          }
        }
      this.countSelection++;
      }

    if (this.countSelection === 2) {
      const firstDate = new Date(this.firstSelectionYear, this.firstSelectionMonth, this.firstSelectionDay);
      const lastDate = new Date(this.lastSelectionYear, this.lastSelectionMonth, this.lastSelectionDay);

      this.verifyFirstDateIsBeforeLastDate(firstDate, lastDate).then(() => this.renderClassesBySelectedMonth());
    }

    this.emitDateEvent();
    this.toggleCalendar();

  }

  verifyFirstDateIsBeforeLastDate(firstDate, lastDate): Promise<boolean> {

    return new Promise((resolve, reject) => {

      if ( moment(firstDate).isBefore(lastDate)) {
        resolve(true);
        return;
      }

      if (moment(firstDate).isAfter(lastDate)) {
        const _firstSelectionDay = this.firstSelectionDay;
        const _firstSelectionMonth = this.firstSelectionMonth;
        const _firstSelectionYear = this.firstSelectionYear;

        this.firstSelectionDay = this.lastSelectionDay;
        this.firstSelectionMonth = this.lastSelectionMonth;
        this.firstSelectionYear = this.lastSelectionYear;

        this.lastSelectionDay = _firstSelectionDay;
        this.lastSelectionMonth = _firstSelectionMonth;
        this.lastSelectionYear = _firstSelectionYear;

        resolve(true);
      }

    });
  }

  last7Days() {
    this.month = new Date().getMonth();

    this.setMonthData();

    this.firstSelectionDay = new Date().getDate();
    this.firstSelectionMonth = new Date().getMonth();
    this.firstSelectionYear = new Date().getFullYear();

    for (let i = 0; i < 7; i++) {
      this.firstSelectionMonth = this.firstSelectionDay === 1 ?
                                 this.firstSelectionMonth - 1 :
                                 this.firstSelectionMonth < 0 ? 11 :
                                 this.firstSelectionMonth;

    this.firstSelectionYear = this.firstSelectionMonth === 1 ?
                              this.firstSelectionYear - 1 :
                              this.firstSelectionMonth < 0 ?
                              this.firstSelectionYear - 1 :
                              this.firstSelectionYear;

      if (this.firstSelectionDay === 1) {
        this.firstSelectionDay = new Date(this.firstSelectionYear, this.firstSelectionMonth + 1, 0).getDate();
      } else {
        this.firstSelectionDay = this.firstSelectionDay - 1;
      }
    }

    this.lastSelectionDay = new Date().getDate();
    this.lastSelectionMonth = new Date().getMonth();
    this.lastSelectionYear = new Date().getFullYear();

    this.emitDateEvent();
    this.renderClassesBySelectedMonth().then(() => this.toggleCalendar());
  }

  last15Days() {
    this.month = new Date().getMonth();

    this.setMonthData();

    this.firstSelectionDay = new Date().getDate();
    this.firstSelectionMonth = new Date().getMonth();
    this.firstSelectionYear = new Date().getFullYear();

    for (let i = 0; i < 15; i++) {
      this.firstSelectionMonth = this.firstSelectionDay === 1 ?
                                 this.firstSelectionMonth - 1 :
                                 this.firstSelectionMonth < 0 ? 11 :
                                 this.firstSelectionMonth;

      this.firstSelectionYear = this.firstSelectionMonth === 1 ?
                                this.firstSelectionYear - 1 :
                                this.firstSelectionMonth < 0 ?
                                this.firstSelectionYear - 1 :
                                this.firstSelectionYear;

      if (this.firstSelectionDay === 1) {
        this.firstSelectionDay = new Date(this.firstSelectionYear, this.firstSelectionMonth + 1, 0).getDate();
      } else {
        this.firstSelectionDay = this.firstSelectionDay - 1;
      }
    }

    this.lastSelectionDay = new Date().getDate();
    this.lastSelectionMonth = new Date().getMonth();
    this.lastSelectionYear = new Date().getFullYear();

    this.emitDateEvent();
    this.renderClassesBySelectedMonth().then(() => this.toggleCalendar());
  }

  currentMonth() {
    this.month = new Date().getMonth();

    this.setMonthData();

    this.firstSelectionDay = 1;
    this.firstSelectionMonth = new Date().getMonth();
    this.firstSelectionYear = new Date().getFullYear();

    this.lastSelectionDay = this.daysInMonth;
    this.lastSelectionMonth = new Date().getMonth();
    this.lastSelectionYear = new Date().getFullYear();

    this.emitDateEvent();
    this.renderClassesBySelectedMonth().then(() => this.toggleCalendar());
  }

  last3Months() {
    let last3MonthsNumber = 0;
    this.month = new Date().getMonth();

    this.setMonthData();

    if ((new Date().getMonth() - 3) < 0 && last3MonthsNumber === 0) {
      last3MonthsNumber = 9;
    } else if ((new Date().getMonth() - 2) < 0 && last3MonthsNumber === 0) {
      last3MonthsNumber = 10;
    } else if ((new Date().getMonth() - 1) < 0 && last3MonthsNumber === 0) {
      last3MonthsNumber = 11;
    } else {
      last3MonthsNumber = (new Date().getMonth() - 3);
    }

    this.firstSelectionDay = new Date().getDate();
    this.firstSelectionMonth = new Date().getMonth() === 1 ? 10 : last3MonthsNumber;

    this.firstSelectionYear = new Date().getMonth() === 1 ?
                              new Date().getFullYear() - 1 :
                              (new Date().getMonth() - 1) < 0 ?
                              new Date().getFullYear() - 1 :
                              new Date().getFullYear();

    this.lastSelectionDay = new Date().getDate();
    this.lastSelectionMonth = new Date().getMonth();
    this.lastSelectionYear = new Date().getFullYear();

    this.emitDateEvent();
    this.renderClassesBySelectedMonth().then(() => this.toggleCalendar());
  }

  clear() {
    const tds = this.elRef.nativeElement.querySelectorAll('.calendar-frame table tbody tr td');

    for (let i = 0; i < tds.length; i++) {
      tds[i].classList.remove('first', 'last', 'middle');
    }

    this.countSelection = 0;
    this.lastSelectionDay = 0;
    this.firstSelectionDay = 0;
  }

  clearLastDay() {
    const tds = this.elRef.nativeElement.querySelectorAll('.calendar-frame table tbody tr td');

    for (let i = 0; i < tds.length; i++) {
      tds[i].classList.remove( 'last', 'middle');
    }

    this.countSelection = 1;
    this.lastSelectionDay = 0;
  }

  clearFirstDay() {
    const tds = this.elRef.nativeElement.querySelectorAll('.calendar-frame table tbody tr td');

    for (let i = 0; i < tds.length; i++) {
      tds[i].classList.remove( 'first', 'middle');
    }

    this.firstSelectionDay = 0;
  }

  clickOutListener() {
    const self = this;
    document.addEventListener('click', function(e: any) {
      if (e.target.closest('.datepicker')) { return; }

      if (self.showCalendar) {
        self.toggleCalendar();
      }
    });
  }

  emitDateEvent() {

    this.filter.emit({
      firstSelection: {
        day: this.firstSelectionDay,
        year: this.firstSelectionYear,
        month: this.firstSelectionMonth + 1,
      },
      lastSelection: {
        day: this.lastSelectionDay,
        year: this.lastSelectionYear,
        month: this.lastSelectionMonth + 1,
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/datepicker/datepicker.component.ts